"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagStorage = void 0;
const core_1 = require("../../core");
__exportStar(require("./errors"), exports);
__exportStar(require("./types"), exports);
// Initial configuration
core_1.Log.logLevel = core_1.LogLevels.Error;
core_1.Log.environment = core_1.ENVIRONMENT.QA;
class FeatureFlagStorage {
    constructor(featureFlag) {
        this.featureFlag = undefined;
        this.getFeatureFlag = () => {
            return this.featureFlag;
        };
        this.setFeatureFlag = (featureFlag) => {
            this.featureFlag = featureFlag;
            return this.featureFlag;
        };
        this.canI = (key) => {
            if (!this.featureFlag) {
                return false;
            }
            if (!this.featureFlag.has(key)) {
                core_1.Log.error(`Feature flag with key "${key}" not found`);
                return false;
            }
            return !!this.featureFlag.get(key);
        };
        this.featureFlag = featureFlag;
    }
}
exports.FeatureFlagStorage = FeatureFlagStorage;
//# sourceMappingURL=index.js.map